import { useQueryClient, useMutation } from '@tanstack/react-query';
import { fetcher } from '../utils';
import { ADMIN_MARKER_DELETE, MARKER, ADMIN_MARKERS_ALL } from '../queryKeys';

export const useAdminDeleteMarker = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (marker_id: string): Promise<void> => {
    const response = await fetcher(`/v2/admin/markers/${marker_id}`, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 204)
      throw new Error((await response.json()).error ?? 'Did not work!');

    queryClient.invalidateQueries({ queryKey: ADMIN_MARKERS_ALL });
    queryClient.invalidateQueries({
      queryKey: MARKER,
      exact: false,
    });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_MARKER_DELETE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
